import React, { createContext, useContext, useState } from 'react';
import Snackbar from '../Components/UI/Snackbar';

const SnackbarContext = createContext();

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return context;
};

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState(null);

  const showSnackbar = (message, type = 'info', duration = 3000) => {
    const id = Date.now();
    const newSnackbar = { id, message, type, duration };
    setSnackbar(newSnackbar);
  };

  const hideSnackbar = () => {
    setSnackbar(null);
  };

  const value = {
    showSnackbar,
    hideSnackbar,
  };

  return (
    <SnackbarContext.Provider value={value}>
      {children}
      {snackbar && (
        <Snackbar
          key={snackbar.id}
          message={snackbar.message}
          type={snackbar.type}
          duration={snackbar.duration}
          onClose={hideSnackbar}
        />
      )}
    </SnackbarContext.Provider>
  );
};
